import styles from "./LoadingOverlay.module.scss"

import LoadingIcon from "@/lib/components/ui/LoadingIcon/LoadingIcon"

const LoadingOverlay = ({
	show,
	message,
}: {
	show: boolean
	message: string
}) => {
	if (show) {
		return (
			<div className={styles.loading_overlay}>
				<div className={styles.container}>
					<div className={styles.icon}>
						<LoadingIcon />
					</div>
					<div className={styles.message}>{message}</div>
				</div>
			</div>
		)
	} else {
		return <div></div>
	}
}

export default LoadingOverlay
